import React from 'react';

const agencySans = "font-[Calibri,'Calibri_Light','Segoe_UI',sans-serif]";

/** Phone canvas aspect ratio from Jessica prototype (906×1920). */
const PHONE_ASPECT = '906 / 1920';

/** Thumbnail-matched lavender panel gradient (white top → #f0e2ff bottom). */
export const JESSICA_PANEL_GRADIENT = 'linear-gradient(180deg, #ffffff 0%, #f0e2ff 100%)';

/** Outer bezel radius — keep in sync with embed CSS in Neevii_App_prototype mobile.css */
export const JESSICA_PHONE_RADIUS = '14% / 6.6%';

export const JESSICA_PHONE_SHADOW =
  '0 18px 36px -10px rgba(124, 58, 237, 0.22), 0 8px 16px -4px rgba(30, 27, 75, 0.15)';

const DEMO_SRC = '/demos/ouro/index.html?embed=1';

/**
 * Live Ouro demo — static Vite build served from /demos/ouro/.
 * Rebuild via Neevii_App_prototype/scripts/build-for-website.ps1 before deploy.
 */
export function JessicaDemoEmbed({ className = '', variant = 'inline', showCaption }) {
  const isModal = variant === 'modal';
  const captionVisible = showCaption ?? !isModal;

  if (isModal) {
    return (
      <div className={`flex h-full w-full items-center justify-center ${className}`}>
        <div
          className="relative w-auto max-w-full overflow-hidden"
          style={{
            aspectRatio: PHONE_ASPECT,
            height: 'min(88dvh, 960px)',
            width: 'min(100%, calc(min(88dvh, 960px) * 906 / 1920))',
            borderRadius: JESSICA_PHONE_RADIUS,
            boxShadow: JESSICA_PHONE_SHADOW,
          }}
        >
          <iframe
            src={DEMO_SRC}
            title="Ouro — Creative Flow Whiteboard interactive demo"
            className="absolute inset-0 h-full w-full border-0 bg-transparent"
            loading="eager"
            allow="microphone; autoplay"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`mx-auto w-full max-w-[min(100%,420px)] ${className}`}>
      <div
        className="relative w-full overflow-hidden border border-white/15 bg-black/35 shadow-xl backdrop-blur-sm"
        style={{ aspectRatio: PHONE_ASPECT }}
      >
        <iframe
          src={DEMO_SRC}
          title="Ouro — Creative Flow Whiteboard interactive demo"
          className="absolute inset-0 h-full w-full border-0 bg-transparent"
          loading="lazy"
          allow="microphone; autoplay"
        />
      </div>
      {captionVisible && (
        <p
          className={`mt-3 text-center text-sm leading-relaxed text-white/70 sm:text-base ${agencySans}`}
        >
          Ouro — AI with memory you control
          <span className="block text-white/50">Tap to open the interactive demo</span>
        </p>
      )}
    </div>
  );
}
